module.exports = __webpack_public_path__ + "img/微信图片_20210903171925.3fc6bc26.png";